<template>
  <v-dialog v-model="dialog" max-width="650" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" v-bind="attrs" v-on="on">
        <v-icon left>mdi-plus</v-icon> Add Equipment
      </v-btn>
    </template>
    <v-card>
      <ModalHeader
        title="Add Equipment"
        icon="mdi-clipboard-list"
        @close="dialog = false"
      />
      <v-card-text class="pa-4">
        <v-text-field
          outlined
          dense
          v-model="form.name"
          label="Equipment Name"
          prepend-icon="mdi-toolbox"
          :rules="[rules.required]"
        ></v-text-field>
        <v-select
          outlined
          dense
          v-model="form.type"
          :items="typeOptions"
          label="Type"
          prepend-icon="mdi-shape"
        ></v-select>
        <v-text-field
          outlined
          dense
          v-model="form.category"
          label="Category"
          prepend-icon="mdi-tag"
          hint="e.g. Security, Electrical, Cleaning"
          persistent-hint
        ></v-text-field>
        <v-textarea
          outlined
          dense
          v-model="form.designated_location"
          label="Designated Location"
          prepend-icon="mdi-map-marker"
          rows="2"
          auto-grow
        ></v-textarea>
        <v-text-field
          outlined
          dense
          v-model.number="form.sort_order"
          label="Sort Order"
          type="number"
          min="0"
          prepend-icon="mdi-sort"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn color="primary" :loading="loading" @click="submit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        name: "",
        type: "equipment",
        category: "",
        designated_location: "",
        sort_order: 0,
      },
      typeOptions: [
        { text: "Facility Equipment", value: "equipment" },
        { text: "Tool", value: "tool" },
      ],
      rules: {
        required: (v) => !!v || "Required",
      },
    };
  },
  methods: {
    ...mapActions({
      add_equipment: "facilities/add_equipment",
    }),
    async submit() {
      if (!this.form.name) return;
      this.loading = true;
      try {
        await this.add_equipment(this.form);
        this.close();
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    close() {
      this.dialog = false;
      this.form = {
        name: "",
        type: "equipment",
        category: "",
        designated_location: "",
        sort_order: 0,
      };
    },
  },
};
</script>
